import { render, staticRenderFns } from "./iteration_popover.vue.js?vue&type=template&id=42a45727!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./iteration_popover.vue?vue&type=template&id=42a45727"
import script from "./iteration_popover.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./iteration_popover.vue?vue&type=script&lang=js"
export * from "./iteration_popover.vue.js?vue&type=script&lang=js!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./iteration_popover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42a45727')) {
      api.createRecord('42a45727', component.options)
    } else {
      api.reload('42a45727', component.options)
    }
    module.hot.accept("./iteration_popover.vue.js?vue&type=template&id=42a45727!=!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./iteration_popover.vue?vue&type=template&id=42a45727", function () {
      api.rerender('42a45727', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ee/app/assets/javascripts/issuable/popover/components/iteration_popover.vue"
export default component.exports